import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { Brain, Activity, AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-10 md:py-16 bg-stone-950 px-4 sm:px-6 lg:px-8" data-id="element-416">
      <div className="max-w-4xl mx-auto" data-id="element-417">
        <FadeIn data-id="element-418">
          <div className="flex items-center gap-3 mb-6" data-id="element-419">
            <AlertTriangle className="w-6 h-6 text-amber-500" data-id="element-420" />
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-421">
              El verdadero problema no es el sueño
            </h2>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center mt-12" data-id="element-422">
          <FadeIn delay={0.2} direction="right" data-id="element-423">
            <div className="space-y-6 text-lg text-stone-300 leading-relaxed" data-id="element-424">
              <p data-id="element-425">
                El insomnio por ansiedad no es una falta de sueño, es una{' '}
                <strong className="text-white font-semibold" data-id="element-426">
                  sobrecarga de la memoria de trabajo
                </strong>
                .
              </p>
              <p data-id="element-427">
                Tu cerebro se niega a "apagarse" porque tiene miedo de que
                olvides algo vital. Para tu sistema nervioso, un pendiente sin
                anotar tiene el mismo peso que un depredador acechando tu cueva.
              </p>
              <p data-id="element-428">
                Mientras esa información siga dando vueltas en tu cabeza, tu
                cuerpo liberará cortisol para mantenerte alerta. No importa
                cuánto intentes "relajarte", estás en modo supervivencia.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} direction="left" data-id="element-429">
            <div className="relative" data-id="element-430">
              <div className="absolute inset-0 bg-gradient-to-tr from-amber-900/40 to-stone-800/40 rounded-3xl transform rotate-3 scale-105" data-id="element-431" />
              <div className="relative bg-stone-900 border border-stone-800 rounded-3xl p-8 shadow-2xl" data-id="element-432">
                <div className="flex justify-center mb-8" data-id="element-433">
                  <div className="relative" data-id="element-434">
                    <Brain className="w-24 h-24 text-amber-400" data-id="element-435" />
                    <Activity className="w-12 h-12 text-amber-500 absolute -bottom-2 -right-2 animate-pulse" data-id="element-436" />
                  </div>
                </div>
                <div className="space-y-4" data-id="element-437">
                  <div className="h-2 bg-stone-800 rounded-full overflow-hidden" data-id="element-438">
                    <div className="h-full bg-amber-500 w-[90%] rounded-full" data-id="element-439" />
                  </div>
                  <p className="text-sm text-stone-400 text-center uppercase tracking-wider font-medium" data-id="element-440">
                    Carga Cognitiva al 90%
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}